module.exports = __webpack_public_path__ + "static/media/faq-earn-points.d5be4322.png";